const $ = jQuery;
const ScrollListener = function(args){
	this.args = args;
	this.init();
}

ScrollListener.prototype = {
	init: function(){
		if (this.args.sel){
			this.$sel = $(this.args.sel);
		}
		else if (this.args.id) {
			this.$sel = $("#gallery-"+this.args.id+" .gallery");
		}
		else {
			alert('Scroll Listser: Enable to select container \n Please call me with an id or a selector !!!');
			return;
		}
		var SL = this;
		setTimeout(function(){SL.loadPositions()}, 100);
		this.$slides = $('.item', this.$sel).css('height', this.args.slidesHeight?this.args.slidesHeight:'700vh');
		this.loadPositions();
		this.initAnimations();
		this.currentSlides = [];
		
		$(window).resize(function(){
			SL.loadPositions();
		});
		$(window).scroll(function(d){
			SL.scrollTop = $(window).scrollTop();
			let slides = SL.getCurrentSlides();
			if (!slides.length){
				SL.currentSlide = null;
				SL.$slides.removeClass('active');
				return;
				
			}

			if (slides != SL.currentSlides){
				SL.$sel.trigger('changedSlide', {prev: SL.currentSlides, current: slides});
				SL.currentSlides = slides;
				SL.$slides.removeClass('active');
			}
			if (!slides || slides.length == 0) return;
			for (var i=0; i<slides.length;i++){
				let slide = slides[i];
				slide.$sel.addClass('active');
				var slideIndex = 1+slide.$sel.index();
				var animations = SL.getAnimations(slideIndex);
				SL.executeAnimations(animations, slide);
			}


		});
				
	},

	loadPositions: function(){
		var positions = [];
		this.windowHeight = $(window).height();
		this.$slides.each(function(){
			positions[positions.length] = 
			{	top:$(this).offset().top,
				bottom:$(this).offset().top+$(this).height(),
				$sel:$(this)
			};
		});
		return this.positions = positions;

	},


	getAnimations: function(slideIndex){
		var animations = null;
		this.args.animations.forEach(function(a){
			if (a.slide == slideIndex){
				animations =  a.animations;
			}
		});
		return animations;
	},

	initAnimations: function(){
		var SL =this;
		this.args.animations.forEach(function(a){
			let $slide = $(SL.args.sel+" .item:nth-child("+a.slide+")");
			a.animations.forEach(function(d){
				var args = {
					$sel : $slide.find(d.sel),
					progress: 0,
					param: d.param
				}
				if (args.$sel.length < 1) return;
				if (typeof SL.fn[d.fn] ==='function' ){
					SL.fn[d.fn](args);
				}
			});
		});
	},

	getCurrentSlides: function(){
		var s = this.scrollTop;
		var wh = this.windowHeight;
		let slides = [];
		for(var i=0; i<this.positions.length; i++){
			if(s >= this.positions[i].top - wh && s < this.positions[i].bottom){
				var t = this.positions[i].top-wh;
				var b = this.positions[i].bottom;
				this.positions[i].progress = (100*(s-t)/(b-t));
				slides[slides.length] = this.positions[i];

			}
		}
		return slides;
	},

	executeAnimations: function(animations, currentSlide, _progress){
		if (!animations) return;

		var SL  =this;
		animations.forEach(function(d){
			var progress  = Math.floor(100*(currentSlide.progress-d.start)/(d.end - d.start));
			if ((progress < 0 || progress > 100) && (d.fn=='svgnav' || d.fn=='timeto' || d.fn=="valueto")){
				return;
			}
			if (progress < 0) progress = 0;
			if (progress>100) progress = 100;
			var args = {
				$sel : currentSlide.$sel.find(d.sel),
				progress: _progress?_progress:progress,
				param: d.param,
				scrollTop: SL.scrollTop,
				currentSlide: currentSlide,
				windowHeight: SL.windowHeight
			}
			var fns = d.fn.split(' ');
			fns.forEach(function(f){
				if (typeof SL.fn[f] ==='function' ){
					SL.fn[f](args);
				}
				else console.log('function '+d.fn+"not found");
			});
			
		})
	},

	
	fn: {
		fadeIn: function(o){
			var p = o.progress;
			o.param = o.param?o.param:500;
			o.$sel.css('opacity', p/100 );
		},
		fadeInOut: function(o){
			var d = o.param?o.param:1500;
			var p = o.progress;
			if (p>1 && p<100){
				o.$sel.fadeIn(d);
			}
			else {
				o.$sel.fadeOut(d);
			}
		},
		fadeOut: function(o){
			var p = o.progress;
			o.$sel.css('opacity', 1 - p/100 );
		},
		enterLeft: function(o){
			var p = o.progress;
			o.param = o.param?o.param:500;
			o.$sel.css('transform', 'translateX('+((p-100)*o.param/100)+'px)');
		},
		enterRight: function(o){
			var p = o.progress;
			o.param = o.param?o.param:500;
			o.$sel.css('transform', 'translateX('+((100-p)*o.param/100)+'px)');
		},
		exitLeft: function(o){
			var p = o.progress;
			o.param = o.param?o.param:500;
			o.$sel.css('transform', 'translateX(-'+(p*o.param/100)+'px)');	
		},
		exitRight: function(o){
			var p = o.progress;
			o.param = o.param?o.param:500;
			o.$sel.css('transform', 'translateX('+(p*o.param/100)+'px)');	
		},
		zoomIn: function(o){
			var p = o.progress;
			var zmax = o.param?o.param:1.2;
			o.$sel.css('transform', 'scale('+(1+ p*(zmax-1)/100)+')' );
		},
		drawpath: function(o){
			if (!o.$sel[0] || !o.$sel[0].getTotalLength) {
				console.error(o.$sel.selector +' path can not be drawn');
				return;
			}

			var p = o.progress;
			var l = o.$sel[0].getTotalLength();
			let v = (100-p)*l/100;
			if (o.param === 'reverse'){
				v = -v;
			}
			o.$sel.css('strokeDashoffset',v);
			
		},
		timeto: function(o){
			var p = o.progress;
			let convertToInt = function(v){
				return parseInt(v.split(':')[0])*60+parseInt(v.split(':')[1]);
			}
			let args = o.param.split(' ');
			const s = convertToInt(args[0]);
			const e = convertToInt(args[1]);
			let v = s + p*(e-s)/100;
			let h = Math.floor(v/60);
			let step = Math.floor(args[2]);
			if (!step) step = 1;
			let m = Math.floor(v) % 60;
			m = Math.floor(m/step)*step;
			if (m<10) m = "0"+m;
			o.$sel[0].innerHTML = h+':'+m;
		},
		valueto: function(o){
			var p = o.progress;
			let args = o.param.split(' ');
			let v1 = parseFloat(args[0]);
			let v2 = parseFloat(args[1]);
			let v = v1 + p * (v2 -v1)/100;
			v  = v.toFixed(parseInt(args[2]));
			o.$sel[0].innerHTML = v;

		},	
		svgnav: function(o){
			var p = o.progress;
			let s = o.param;
			
			let x = s[0].x+p*(s[1].x-s[0].x)/100;
			let y = s[0].y+p*(s[1].y-s[0].y)/100;
			let z = s[0].z+p*(s[1].z-s[0].z)/100;
			console.log(x,y,z);
			let t = 'translate('+x+'px, '+y+'px) scale('+z+')';
			o.$sel.css('transform', t);
		},
		stick: function(o){
			if (!o.currentSlide){
				o.$sel.css('position', 'absolute').css('top', 0);
				return;
			}

			CL = o;
			var t = o.currentSlide.top;
			var b = o.currentSlide.bottom;
			var h = o.$sel.height();
			var s = o.scrollTop;
			var wh = o.windowHeight;
			//center vertically for mobile.
			var eltop  = Math.max(0, s-t+(wh-h)/2);
			if (s < t){

				o.$sel.css('position', 'absolute').css('top', eltop);
			}

			var margin = Math.max((wh-h)/2,0)
			if (s >= t){
				if (b > s+h+margin){
					o.$sel.css('position', 'fixed').css('top', 0*(s-t+margin));
				}
				else {
					o.$sel.css('position', 'absolute').css('top',b-t-h).css('bottom', 'auto'); 

				}

			}
			
		}
	}

}
window.ScrollListener = ScrollListener;
export default ScrollListener;